module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('a', {
    staticClass: "profile-name",
    on: {
      "click": _vm.showModal
    }
  }, [_vm._v(_vm._s(_vm.name))]), _c('a', {
    staticClass: "profile-img"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.photoUrl,
      "alt": "Avatar"
    }
  })]), _c('ul', {
    staticClass: "profile-dropdown"
  }, _vm._l((_vm.options), function(option) {
    return _c('li', {
      staticClass: "dropdown-item"
    }, [_c('a', {
      on: {
        "click": option.action
      }
    }, [_vm._v(_vm._s(option.name))])])
  }))]), (_vm.modal) ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": _vm.closeModal
    }
  }) : _vm._e(), (_vm.modal) ? _c('a', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closeModal
    }
  }) : _vm._e(), (_vm.modal && !_vm.checkPassword) ? _c('form', {
    staticClass: "modal"
  }, [_vm._m(0), _vm._m(1), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "profile-photo"
  }, [_c('div', {
    staticClass: "img-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.photoUrl,
      "alt": "Avatar"
    }
  })]), _c('input', {
    staticClass: "modal-upload",
    attrs: {
      "name": "photo",
      "id": "photo",
      "type": "file"
    },
    on: {
      "change": _vm.uploadPhoto
    }
  }), _c('label', {
    staticClass: "modal-action",
    attrs: {
      "for": "photo"
    }
  }, [_vm._v("Choose")]), _c('a', {
    staticClass: "delete-action",
    on: {
      "click": _vm.deleteUser
    }
  }, [_vm._v("Delete account")])]), _c('div', {
    staticClass: "profile-info"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('div', {
    staticClass: "input-icon icon-face"
  }), _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "input-line",
    attrs: {
      "name": "name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "blur": function($event) {
        _vm.lockInfo = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }, 'input', {
    placeholder: (_vm.lockInfo ? _vm.name : "New name..."),
    readonly: _vm.lockInfo
  }))]), _c('div', {
    staticClass: "input-box"
  }, [_c('div', {
    staticClass: "input-icon icon-mail"
  }), _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "input-line",
    attrs: {
      "name": "email",
      "type": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "blur": function($event) {
        _vm.lockInfo = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }, 'input', {
    placeholder: (_vm.lockInfo ? _vm.email : "New email..."),
    readonly: _vm.lockInfo
  }))]), _c('a', {
    staticClass: "modal-action",
    class: {
      "action-update": !_vm.lockInfo
    },
    on: {
      "click": _vm.changeInfo
    }
  }, [_vm._v(_vm._s(_vm.lockInfo ? 'Change...' : 'Update'))]), _c('div', {
    staticClass: "input-box"
  }, [_c('div', {
    staticClass: "input-icon icon-lock"
  }), _c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input-line",
    attrs: {
      "name": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": function($event) {
        _vm.lockPassword = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }, 'input', {
    placeholder: (_vm.lockPassword ? "Password" : "New password..."),
    readonly: _vm.lockPassword
  }))]), _c('a', {
    staticClass: "modal-action",
    class: {
      "action-update": !_vm.lockPassword
    },
    on: {
      "click": _vm.activatePassword
    }
  }, [_vm._v(_vm._s(_vm.lockPassword ? 'Change...' : 'Update'))])])])]) : _vm._e(), (_vm.checkPassword) ? _c('div', {
    staticClass: "modal modal-confirm"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input-line",
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _c('a', {
    staticClass: "modal-action action-update",
    on: {
      "click": _vm.reAuth
    }
  }, [_vm._v("Confirm")])]) : _vm._e(), _c('transition', {
    attrs: {
      "name": "note"
    }
  }, [(_vm.message.length > 0) ? _c('notification', {
    attrs: {
      "message": _vm.message
    },
    nativeOn: {
      "click": function($event) {
        _vm.message = ""
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-head"
  }, [_c('a', {
    staticClass: "modal-title"
  }, [_vm._v("Profile")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-head modal-subhead"
  }, [_c('a', {
    staticClass: "modal-title"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2bedd7fe"}!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
// module id = 123
// module chunks = 0